"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _modal = _interopRequireDefault(require("../modal"));
var _button = _interopRequireDefault(require("../button"));
var _svg;
const ConfirmDialog = _ref => {
  let {
    className,
    title,
    message,
    disabled,
    ok,
    cancel,
    onClose
  } = _ref;
  const okMessage = _react.default.useMemo(() => {
    if ((0, _ark.isString)(ok)) return ok;
    return 'Oui';
  }, [ok]);
  const cancelMessage = _react.default.useMemo(() => {
    if ((0, _ark.isString)(cancel)) return cancel;
    return 'Annuler';
  }, [cancel]);
  const handleCancelClick = _react.default.useCallback(() => {
    if ((0, _ark.isFunction)(onClose)) {
      onClose(false);
    }
  }, [onClose]);
  const handleOkClick = _react.default.useCallback(() => {
    if ((0, _ark.isFunction)(onClose)) {
      onClose(true);
    }
  }, [onClose]);
  return /*#__PURE__*/_react.default.createElement(_modal.default, {
    className: (0, _arkReact.concatClassName)('dialog dialog-confirm', className),
    backdrop: true,
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_modal.default.Header, null, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _svg || (_svg = /*#__PURE__*/_react.default.createElement("svg", {
    className: "dialog-icon",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 438.5 438.5",
    fill: "currentColor"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M409.1,109.2c-19.6-33.6-46.2-60.2-79.8-79.8C295.7,9.8,259.1,0,219.3,0c-39.8,0-76.5,9.8-110.1,29.4 C75.6,49,49,75.6,29.4,109.2C9.8,142.8,0,179.5,0,219.3c0,39.8,9.8,76.5,29.4,110.1c19.6,33.6,46.2,60.2,79.8,79.8 c33.6,19.6,70.3,29.4,110.1,29.4s76.5-9.8,110.1-29.4c33.6-19.6,60.2-46.2,79.8-79.8c19.6-33.6,29.4-70.3,29.4-110.1 C438.5,179.5,428.7,142.8,409.1,109.2z M387.4,290.2c-9.7,22.6-22.7,42-39,58.2c-16.3,16.3-35.7,29.3-58.2,39 c-22.6,9.7-46.2,14.6-70.9,14.6s-48.4-4.9-70.9-14.6c-22.6-9.7-42-22.7-58.2-39c-16.3-16.3-29.3-35.7-39-58.2 c-9.7-22.6-14.6-46.2-14.6-70.9c0-24.7,4.9-48.4,14.6-70.9c9.7-22.6,22.7-42,39-58.2c16.3-16.3,35.7-29.3,58.2-39 c22.6-9.7,46.2-14.6,70.9-14.6c24.7,0,48.4,4.9,70.9,14.6c22.6,9.7,42,22.7,58.2,39c16.3,16.3,29.3,35.7,39,58.2 c9.7,22.6,14.6,46.2,14.6,70.9C402,244,397.1,267.7,387.4,290.2z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M217,294c-14.6,0-26.5,12.2-26.5,26.8c0,14.3,11.5,26.8,26.5,26.8s26.8-12.5,26.8-26.8C243.8,306.2,231.6,294,217,294z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M221.5,90.8c-47.1,0-68.7,27.9-68.7,46.7c0,13.6,11.5,19.9,20.9,19.9c18.8,0,11.2-26.8,46.7-26.8c17.4,0,31.4,7.7,31.4,23.7 c0,18.8-19.5,29.6-31,39.4c-10.1,8.7-23.4,23-23.4,53c0,18.1,4.9,23.4,19.2,23.4c17.1,0,20.6-7.7,20.6-14.3 c0-18.1,0.4-28.6,19.5-43.6c9.4-7.3,39-31,39-63.8S266.1,90.8,221.5,90.8z"
  }))), /*#__PURE__*/_react.default.createElement("h2", {
    className: "dialog-title"
  }, title))), /*#__PURE__*/_react.default.createElement(_modal.default.Body, null, message), /*#__PURE__*/_react.default.createElement(_modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "contained",
    onClick: handleCancelClick
  }, cancelMessage), /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "contained",
    color: "primary",
    disabled: disabled,
    onClick: handleOkClick
  }, okMessage)));
};
process.env.NODE_ENV !== "production" ? ConfirmDialog.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  message: _propTypes.default.string.isRequired,
  ok: _propTypes.default.string,
  cancel: _propTypes.default.string,
  onClose: _propTypes.default.func
} : void 0;
ConfirmDialog.defaultProps = {
  className: undefined,
  ok: undefined,
  cancel: undefined,
  onClose: undefined
};
var _default = exports.default = ConfirmDialog;